var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2547_39561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15 12.1875L10.0085 10.2868C10.1168 10.176 10.2454 10.0882 10.387 10.0282C10.5285 9.9683 10.6802 9.93747 10.8335 9.9375H10.9C11.1917 9.9375 11.4715 10.056 11.6778 10.267C11.8841 10.478 12 10.7641 12 11.0625C12 11.3609 11.8841 11.647 11.6778 11.858C11.4715 12.069 11.1917 12.1875 10.9 12.1875H2.1C1.80826 12.1875 1.52847 12.069 1.32218 11.858C1.11589 11.647 1 11.3609 1 11.0625C1 10.7641 1.11589 10.478 1.32218 10.267C1.52847 10.056 1.80826 9.9375 2.1 9.9375H4.58325C5.45831 9.93754 6.29753 10.293 6.91635 10.9258L8.15 12.1875ZM1.55 12.1875H11.45V13.3125C11.45 13.76 11.2762 14.1892 10.9667 14.5057C10.6573 14.8222 10.2376 15 9.8 15H3.2C2.76239 15 2.34271 14.8222 2.03327 14.5057C1.72384 14.1892 1.55 13.76 1.55 13.3125V12.1875Z",
    stroke: "#A9A8AD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75077 8.24998H3.75022M8.15077 7.68749H8.15022M6.50077 8.24998H6.50022M6.50022 6C3.95757 6 1.86262 6.98774 1.58212 9.37497C1.54582 9.68435 1.79662 9.93747 2.10022 9.93747H10.9002C11.2038 9.93747 11.4546 9.68435 11.4183 9.37497C11.1378 6.98774 9.04287 6 6.50022 6Z",
    stroke: "#A9A8AD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67395 15H12.7119C12.9459 15 13.1713 14.9171 13.3428 14.7679C13.5143 14.6186 13.6194 14.4141 13.6368 14.1954L14.1739 4M7.5 4L7.8 6",
    stroke: "#A9A8AD",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.5L12 1.5L13.4688 1",
    stroke: "#A9A8AD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5H15",
    stroke: "#A9A8AD",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2547_39561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFood);
export default __webpack_public_path__ + "static/media/IconFood.4ca940640b2fcbe5a7ec24e874e7949c.svg";
export { ForwardRef as ReactComponent };